<template>
  <div>
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">فیلتر جستجو</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-9 col-12">
            <small id="grp42">وضعیت</small>
            <div dir="rtl">
              <treeselect
                name="demo"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :disabled="disabled"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :clear-on-select="clearOnSelect"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                :append-to-body="appendToBody"
                :options="options"
                v-model="$store.state.CustomerTicketFilters.Grp41"
                :normalizer="normalizer"
                @select="ItemSelected"
                @deselect="ItemDeselect"
              >
                <label slot="option-label" slot-scope="{ labelClassName, node }" :class="labelClassName">{{ node.label }}</label>
              </treeselect>
            </div>
          </div>
          <div class="col-md-3 col-12"></div>
        </div>
        <div class="row mt-2">
          <div class="col-md-2 col-12">
            <small id="LbltarixAz"> از تاریخ </small>
            <date-picker color="dimgray" v-model="AzTarix"  clearable :editable="true" placeholder="از تاریخ"></date-picker>
          </div>
          <div class="col-md-2 col-12">
            <small id="LbltarixAz"> تا تاریخ</small>
            <date-picker color="dimgray" v-model="TaTarix" clearable :editable="true" placeholder="تا تاریخ"></date-picker>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9 col-12"></div>
          <div class="col-lg-3 col-12">
            <button class="btn btn-success mt-4 float-left" dir="ltr" @click.prevent="Search()"><span class="mr-2"> جستـجـو </span><span class="fas fa-search"></span></button>
          </div>
        </div>
      </template>
    </Card>
    <Card>
      <template v-slot:content>
        <BnpGrid :Sortable="true" Selectable :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" :ticketManager="true" v-if="$store.state.renderComponentGrid" :excel="true">
          <template slot="score" slot-scope="props">
            <a href="javascript:;" class="mr-2 badge" @click="GetuserTicket(props.props.id)">
              <i class="fas fa-star text-warning"></i>
            </a>
          </template>
          <template slot="DateTimeLastEdit" slot-scope="props"> {{ props.props.DateTimeLastEdit == null ? '' : props.props.DateTimeLastEdit.substring(11, 16) + '--' + props.props.DateTimeLastEdit.substring(0, 10) }} </template>
          <template slot="DateTimeInsert" slot-scope="props"> {{ props.props.DateTimeInsert.substring(11, 16) }} -- {{ props.props.DateTimeInsert.substring(0, 10) }} </template>
          <template slot="action-slot" slot-scope="props">
            <a href="javascript:;" class="mr-2 badge" @click="goToChatRoom(props.props.TblChatRoomId, props.props.TblUserId, props.props.Id, props.props.TblComboGrpId41, props.props.TblDepartmentId)">
              <h6><span class="fa fa-comments-o hover-info"></span></h6>
            </a>
          </template>
        </BnpGrid>
      </template>
    </Card>
    <b-modal size="lg" centered id="modal-UserTicket">
      <template #modal-header="{ close }">
        <b-button size="sm" variant="outline-danger" @click="close()">
          <span aria-hidden="true">&times;</span>
        </b-button>
        <h5>امتیاز دهی به کاربران تیکت شماره #{{ ticketNumber }}</h5>
      </template>

      <template #default>
        <div dir="rtl">
          <bnp-grid v-if="$store.state.renderComponentGridModal" :propsColumn="ColumnRiz" :propsRows="rows" :hasRowNum="true" :Selectable="false">
            <template slot="score" slot-scope="props">
              <star-rating :show-rating="false" :star-size="15" :inline="true" v-model="props.props.score" @rating-selected="scoreChangeNew(props.props)" :read-only="props.props.score != null ? true : false"> </star-rating>
            </template>
          </bnp-grid>
        </div>
      </template>
      <template #modal-footer="{ cancel }">
        <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()"> بستن </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

export default {
  components: { datePicker: VuePersianDatetimePicker,Card, BnpGrid, SearchableCombo, Treeselect },

  data() {
    return {
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      TaTarix:'',
      AzTarix:'',
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      options: [],
      propsColumn: [
        { name: 'Id', label: 'شماره تیکت', visibility: true },
        { name: 'DepartmentName', label: 'دپارتمان', visibility: true },
        { name: 'Title', label: 'عنوان', visibility: true },
        { name: 'DateTimeInsert', label: 'زمان ایجاد', visibility: true },
        { name: 'DateTimeLastEdit', label: 'زمان آخرین تغییر', visibility: true },
        { name: 'NameGrp41', label: 'وضعیت', visibility: true },
        { name: 'NameUserInsert', label: 'ایجاد کننده', visibility: true },
        { name: 'NamFamResponsible', label: 'مسئول تیکت', visibility: true },
      ],
      propsRows: [],
      ColumnRiz: [
        { name: 'Id', label: 'Id', visibility: false },
        { name: 'NamFam', label: 'نام کاربر', visibility: true },
        { name: 'score', label: 'امتیاز', visibility: true },
      ],
      rows: [],
      userId: this.$session.get('UserInfo').tblUserId,
      UserDepartmentShow: false,
      departmentIdForTicketRefrence: null,
      DataaxiosDepUser: {
        Action: 'Ticket/GetUserDepartment',
        Method: 'Get',
        ArryfildValue: null,
      },
      DataaxiosUserTicket: {
        Action: 'Ticket/GetUserChatTicket',
        Method: 'post',
        ArryfildValue: null,
      },
      usersByDepartment: [],
      selectedUser: [],
      ticketId: null,
      ticketTitle: null,
      note: '',
      ticketItemId: null,
      userId: this.$session.get('UserInfo').tblUserId,
      ticket: [],
      connectionId: null,
      connectionIdChat: null,
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: 'put',
        Action: '',
        Token: this.$session.get('Token'),
        From: 'Body',
      },
      DataAxios_GetData: {
        ArryfildValue: {},
        Method: '',
        Action: '',
        Token: this.$session.get('Token'),
      },
      ticketNumber: null,
    }
  },

  methods: {
    async Search() {
      var DataaxiosDepUser = {
        Action: 'Ticket/GetCustomerTicket',
        Method: 'Post',
        ArryfildValue: {
          ListGrp41: this.$store.state.CustomerTicketFilters.Grp41,
          tblCustomerId: this.$session.get('CustomerInfo').Id,
          AzTarix:this.AzTarix,
          TaTarix:this.TaTarix
        },
      }
      this.$PostData(DataaxiosDepUser)
        .then((response) => {
          this.propsRows = response
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
        .catch((error) => {
          console.error('CATCH', error)
        })
    },
    scoreChangeNew(rating) {
      this.$store.state.OldDataForLog = JSON.stringify(rating)
      rating.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
      this.DataAxiosUpdate.Action = 'Ticket/b_UpdateScoreChatTicket'
      this.DataAxiosUpdate.ArryfildValue = rating
      this.$PutData_Body(this.DataAxiosUpdate)
        .then((data) => {
          if (data.status == 'Ok') {
            this.ScoreDisable = true
            this.$SetLog(rating, 0, 1)

            this.$toasted.success('امتیاز کاربر با موفقیت ثبت شد', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
          } else {
            this.$toasted.error('مشکل در بروزرسانی امتیاز تیکت لطفا مجدد تلاش کنید', {
              action: {
                text: 'بستن',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            })
          }
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    // scoreChange(rating) {
    //   this.$store.state.OldDataForLog = JSON.stringify(rating)

    //   rating.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
    //   this.DataAxiosUpdate.Action = 'Ticket'
    //   this.DataAxiosUpdate.ArryfildValue = rating
    //   this.$PutData_Body(this.DataAxiosUpdate)
    //     .then((data) => {
    //       if (data.status == 'Ok') {
    //         this.ScoreDisable = true
    //         this.$SetLog(rating, 0, 1)

    //         this.$toasted.success('امتیاز تیکت با موفقیت برای کاربر ثبت شد', {
    //           action: {
    //             text: 'بستن',
    //             onClick: (e, toastObject) => {
    //               toastObject.goAway(0)
    //             },
    //           },
    //         })
    //       } else {
    //         this.$toasted.error('مشکل در بروزرسانی تیکت لطفا مجدد تلاش کنید', {
    //           action: {
    //             text: 'بستن',
    //             onClick: (e, toastObject) => {
    //               toastObject.goAway(0)
    //             },
    //           },
    //         })
    //       }
    //     })
    //     .finally(() => {
    //       this.$store.state.renderComponentGridModal = false
    //       this.$nextTick(() => {
    //         this.$store.state.renderComponentGridModal = true
    //       })
    //     })
    // },
    goToChatRoom(chatRoomId, ticketManagerTblUserId, ticketId, tblComboIdTicketStatus, departmentId) {
      this.$router.push({
        name: 'ChatRoom',
        params: {
          chatRoomId: chatRoomId,
          ticketManagerTblUserId: ticketManagerTblUserId,
          ticketId: ticketId,
          tblComboIdTicketStatus: tblComboIdTicketStatus,
          departmentId: departmentId,
        },
      })
    },

    userDepartment() {
      this.$PostData(this.DataaxiosDepUser)
        .then((res) => {
          this.usersByDepartment = res
        })
        .catch((err) => {
          console.error(err)
        })
    },
    ItemSelected(node) {
      this.$store.state.CustomerTicketFilters.Grp41.push(node.id)
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.$store.state.CustomerTicketFilters.Grp41.length; index++) {
        if (this.$store.state.CustomerTicketFilters.Grp41[index] == node.id) {
          this.$store.state.CustomerTicketFilters.Grp41.splice(index, 1)
        }
      }
    },
    GetuserTicket(id) {
      this.ticketNumber = id
      this.DataaxiosUserTicket.Action = 'Ticket/GetUserChatTicket/' + id
      this.$PostData(this.DataaxiosUserTicket)
        .then((response) => {
          // console.log(response);
          if (response.length > 0) {
            this.rows = response
          }
        })
        .finally(() => {
          this.$bvModal.show('modal-UserTicket')
          this.$store.state.renderComponentGridModal = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGridModal = true
          })
        })
    },
  },
  mounted() {
    this.DataAxios_GetData.Action = 'TblCrmCombo/GetComboById'
    this.DataAxios_GetData.Method = 'POST'
    this.DataAxios_GetData.ArryfildValue = { Id: 41 }
    this.$PostData(this.DataAxios_GetData)
      .then((data) => {
        if (data.status != 'Not Ok') {
          this.options = data
        }
      })
      .finally(() => {
        this.Search()
      })

    this.$GetSignalRChat().then((res) => {
      this.connectionIdChat = res.connection.connectionId
      res.invoke('UserJoinGroup', String(this.userId))
      res.on('changeStatus', (ticketId, status) => {
        var ticket = this.propsRows.find((x) => x.Id == ticketId)
        if (ticket == undefined) {
          this.Search()
        } else {
          ticket.NameGrp41 = status
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        }
      })
    })
  },
  beforeDestroy() {
    this.$GetSignalR().then((res) => {
      res.invoke('RemoveFromGroup', this.connectionId, String(this.userId))
    })
    this.$GetSignalRChat().then((res) => {
      res.invoke('UserRemoveChatRoom', this.connectionIdChat, null, String(this.userId))
    })
  },
}
</script>

<style scoped></style>
